import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';

export const tenantsFormConfig: PolluxFormConfig[] = [
  {
    name: 'TenantFileRefNo',
    value: 'TenantFileRefNo',
    disabled: true
  },
  {
    name: 'LeaseName',
    value: 'LeaseName',
    disabled: true
  },
  {
    name: 'LeaseType',
    value: 'LeaseType',
    disabled: true
  },
  {
    name: 'UnitDescription',
    value: 'UnitDescription',
    disabled: true
  },
  {
    name: 'Sector',
    value: 'Sector',
    disabled: true
  },
  {
    name: 'Region',
    value: 'Region',
    disabled: true
  },
  {
    name: 'PrimaryUse',
    value: 'PrimaryUse',
    disabled: true
  },
  {
    name: 'Status',
    value: 'Status',
    disabled: true
  },
  {
    name: 'TenantUse',
    value: 'TenantUse',
    disabled: true
  },
  {
    name: 'LeaseStart',
    value: 'LeaseStart',
    disabled: true,
    isDate: true
  },
  {
    name: 'LeaseExpiry',
    value: 'LeaseExpiry',
    disabled: true,
    isDate: true
  },
  {
    name: 'AreaSqft',
    value: 'AreaSqft',
    disabled: true
  },
  {
    name: 'Covenant',
    value: 'Covenant',
    disabled: true
  },
  {
    name: 'ValuationMethod',
    value: 'ValuationMethod',
    disabled: true
  },
  {
    name: 'NextReview',
    value: 'NextReview',
    disabled: true,
    isDate: true
  },
  {
    name: 'EarliestTermination',
    value: 'EarliestTermination',
    disabled: true,
    isDate: true
  },
  {
    name: 'PeriodToTermination',
    value: 'PeriodToTermination',
    disabled: true
  },
  {
    name: 'BreakType',
    value: 'BreakType',
    disabled: true
  },
  {
    name: 'EffectiveBreak',
    value: 'EffectiveBreak',
    disabled: true,
    isDate: true
  },
  {
    name: 'PeriodToBreak',
    value: 'PeriodToBreak',
    disabled: true
  },
  {
    name: 'PeriodToExpiry',
    value: 'PeriodToExpiry',
    disabled: true
  },
  {
    name: 'VoidExpiryByBreak',
    value: 'VoidExpiryByBreak',
    disabled: true
  },
  {
    name: 'RentFreePeriod',
    value: 'RentFreePeriod',
    disabled: true
  },
  {
    name: 'GroundRent',
    value: 'GroundRent',
    disabled: true
  },
  {
    name: 'ContractedRent',
    value: 'ContractedRent',
    disabled: true
  },
  {
    name: 'DeemedRent',
    value: 'DeemedRent',
    disabled: true
  },
  {
    name: 'GrossValue',
    value: 'GrossValue',
    disabled: true
  },
  {
    name: 'RentalValue',
    value: 'RentalValue',
    disabled: true
  },
  {
    name: 'VacantPeriod',
    value: 'VacantPeriod',
    disabled: true
  },
  {
    name: 'ErvRatePerSqft',
    value: 'ErvRatePerSqft',
    disabled: true
  },
  {
    name: 'RentRatePerSqft',
    value: 'RentRatePerSqft',
    disabled: true
  },
  {
    name: 'ErvVacancyLoss',
    value: 'ErvVacancyLoss',
    disabled: true
  },
  {
    name: 'Froth',
    value: 'Froth',
    disabled: true
  },
  {
    name: 'PercentErv',
    value: 'PercentErv',
    disabled: true
  },
  {
    name: 'PercentRent',
    value: 'PercentRent',
    disabled: true
  },
  {
    name: 'PercentErvVacancyLoss',
    value: 'PercentErvVacancyLoss',
    disabled: true
  },
  {
    name: 'PercentFroth',
    value: 'PercentFroth',
    disabled: true
  },
  {
    name: 'ErvUplift',
    value: 'ErvUplift',
    disabled: true
  },
  {
    name: 'ErvVoidLoss',
    value: 'ErvVoidLoss',
    disabled: true
  },
  {
    name: 'PercentErvUpliftPerRent',
    value: 'PercentErvUpliftPerRent',
    disabled: true
  },
  {
    name: 'PercentErvUpliftPerTotalRent',
    value: 'PercentErvUpliftPerTotalRent',
    disabled: true
  },
  {
    name: 'HardcoreYield',
    value: 'HardcoreYield',
    disabled: true
  },
  {
    name: 'FrothYield',
    value: 'FrothYield',
    disabled: true
  },
  {
    name: 'CostDeductions',
    value: 'CostDeductions',
    disabled: true
  },
  {
    name: 'CapitalisationGroup',
    value: 'CapitalisationGroup',
    disabled: true
  },
  {
    name: 'DcfExitYld',
    value: 'DcfExitYld',
    disabled: true
  },
  {
    name: 'ReversionYield',
    value: 'ReversionYield',
    disabled: true
  },
  {
    name: 'OwnerUserDescription',
    value: 'OwnerUserDescription',
    disabled: true
  },
  {
    name: 'DateCreated',
    value: 'DateCreated',
    disabled: true,
    isDate: true
  },
  {
    name: 'ModifiedByUserDescription',
    value: 'ModifiedByUserDescription',
    disabled: true
  },
  {
    name: 'DateModified',
    value: 'DateModified',
    disabled: true,
    isDate: true
  },
  {
    name: 'UnitOfLengthSymbol',
    value: 'UnitOfLengthSymbol',
    disabled: true,
  },
  {
    name: 'CurrencySymbol',
    value: 'CurrencySymbol',
    disabled: true,
  }
];
